import {UploadRetryOptions} from './upload.types';

export async function retryWithBackoff(
  requestHandler: () => Promise<Response>,
  onError?: (error: any, attempt: number) => void,
  onDone?: (result: Response | null) => Promise<void> | void,
  options: UploadRetryOptions = {}
): Promise<Response | null> {
  const {
    maxAttempts = 5,
    baseDelay = 1000,
    maxDelay = 10000,
    isRetryable = () => true,
  } = options;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    let error: any;
    try {
      const response = await requestHandler();

      if (!response.ok) {
        error = { status: response.status, statusText: response.statusText };
        onError?.(error, attempt);
      } else {
        if (onDone) await onDone(response);
        return response;
      }
    } catch (e) {
      error = e;
      onError?.(e, attempt);
    }

    if (!isRetryable(error)) {
      break;
    }

    // Backoff delay before retry
    if (attempt < maxAttempts) {
      const delay = Math.min(baseDelay * (2 ** (attempt - 1)), maxDelay);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }

  if (onDone) await onDone(null);
  return null;
}
